import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DanaDataService {

  constructor(private http: HttpClient) { }

  getDANAEventHeatMaps(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getNowcastModelInputHeatMaps'
    return this.http.post<any>(url, postData)
  }

  getDanaCycloneData(postData){
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/nowcastInputData'
    return this.http.post<any>(url, postData)
  }

  getLast3HourTimestamp(inputTimestamp: number): number {
    const THREE_HOURS_IN_MS = 3 * 60 * 60 * 1000;
    return inputTimestamp - THREE_HOURS_IN_MS;
  }

  getDanaCycloneChartData(postData): Observable<any> {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getCTTChartData'
    return this.http.post<any>(url, postData)
  }

  // convertTimestampToBlockValue(ts: number): any {
  //   ts = Number(ts);
  //   let hours = new Date(ts).getHours();
  //   const minutes = new Date(ts).getMinutes();
  //   let amPm = 'A.M';
  //   if (hours == 12) {
  //     hours = 12;
  //     amPm = 'P.M';
  //   }
  //   if (hours > 12) {
  //     hours = hours - 12;
  //     amPm = 'P.M';
  //   }
  //   return hours.toString() + ':' + minutes.toString().padStart(2, '0') + ' ' + amPm;
  // }

  convertTimestampToBlockValue(ts: number): string {
    ts = Number(ts);
    const date = new Date(ts);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_10MINS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_10MINS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString().padStart(2, '0') + ':' + startminutes.toString().padStart(2, '0') + ' ' + startamPm + ' - ' + endhours.toString().padStart(2, '0') + ':' + endminutes.toString().padStart(2, '0') + ' ' + endamPm;
  }

  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = []

    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  getHeatMap(url) {
    let dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          let obj = this.setMapData(data);
          resolve(obj);
        });
    });
    return dataPromise;
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    for (let block of Object.keys(data)) {
      for (let property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  getTimeForDate(ts) {
    const date = new Date(ts);
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Format to 24-hour HH:mm
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;

    return formattedTime;
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  getChartData(formattedChartData: any[], params: any): any {
    // let locType = params['locType'] !== 'STATE' ? 'Districts' : 'Blocks';
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(params.locType) - 1];
    let firstLevel: any = hie[hie.indexOf(params.locType) + 1];
    let locType = firstLevel.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    if (!formattedChartData || formattedChartData.length === 0) {
      return {}; // return empty if no data
    }

    // Extract timestamps (keys except "Rainfall Band")
    const timestamps = Object.keys(formattedChartData[0]).filter(key => key !== "Rainfall Band");

    // Format timestamps to readable time like "08:30"
    const categories = timestamps.map(ts => {
      const date = new Date(Number(ts));
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    });

    const colorMap: { [key: string]: string } = {
      "no rainfall": "#ffffff",
      "very light rainfall": "#C3FDCA",
      "light rainfall": "#00FE08",
      "moderate rainfall": "#038500",
      "heavy rainfall": "#FDBFC9",
      "very heavy rainfall": "#FC0300",
      "extremely heavy rainfall": "#610301"
    };

    // Dynamically generate series for each Rainfall Band
    const series = formattedChartData.map(item => ({
      name: item["Rainfall Band"],
      type: 'column',
      data: timestamps.map(ts => item[ts] || 0),
      color: colorMap[item["Rainfall Band"]] || "#808080" // default color if not found
    }));

    const chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: '#000000'
      },
      title: {
        text: '',
        style: { color: '#ffffff' }
      },
      xAxis: {
        categories: categories,
        labels: {
          style: { color: '#ffffff' }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `No of Wards`,
          style: {  color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        labels: {
          style: {  color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        gridLineColor: '#808080'
      },
      legend: {
         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '12px',
    fontWeight: 'normal'
           }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      series: series,
      credits: {
        enabled: false
      }
    };

    return chartOptions;
  }

  setChartData(data, ProjConstants) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj = {};
      for (const item of Object.keys(data[key])) {

        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['RAINFALL']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }
}
